import React from 'react';

const PlusCircleIcon = () => (
  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.33312 5.55729V11.1128M5.55534 8.33507H11.1109M15.2776 8.33507C15.2776 12.1704 12.1684 15.2795 8.33312 15.2795C4.49781 15.2795 1.38867 12.1704 1.38867 8.33507C1.38867 4.49976 4.49781 1.39062 8.33312 1.39062C12.1684 1.39062 15.2776 4.49976 15.2776 8.33507Z" stroke="#515A6B" strokeWidth="1.04167" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default PlusCircleIcon;
